export default {
	game: {
		maintenance: 'Dalam Pemeliharaan',
		maintenance_tip: 'Sementara tidak dapat diakses',
		no_more_data: 'Tidak ada data lagi',
		search_game_name: 'Cari nama game...',
		selected: 'Terpilih',
		type: 'Tipe',
		all_types: 'Semua Tipe',
		secondary: 'Sekunder',
		secondary_category: 'Kategori Sekunder',
		no_related_games: 'Tidak ditemukan game terkait',
		reset_all: 'Reset Semua',
		end_of_list: 'Akhir Daftar',
		game_details: 'Detail Game',
		play: 'Main',
		bonus_cannot_wagered: 'Bonus tidak dapat dipertaruhkan',
		entering_game: 'Memasuki game, harap tunggu...',
		entering_game_short: 'Memasuki Game...',
		game_types: 'Jenis Game',
		game_providers: 'Penyedia Game',
		sign_up: 'Daftar',
		search: 'Cari',
		all_providers: 'Semua Penyedia',
		loading: 'Memuat...',
		my_bet: 'Taruhan Saya'
	}
};